import React, { CSSProperties, useMemo } from 'react';
import {shallowEqual, useSelector } from 'umi';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { getServiceFilterParams } from '@/pages/dashboard/utils/utils';
import dataFormat from "@home/utils/dbDataFormat/dataFormat";
import { getDefaultUtcDateValue } from '@/pages/dashboard/utils/dateUtils';

interface IComProps { 
  style?: CSSProperties;
  className?: string;
  children:React.ReactNode;
  // api 请求地址
  api: string;
  // 前端取数的数据key
  dataKey?: string;
  tableFormat?:  string;
  byType?: string;
  metric?: string;
}

export default function CreatorProfileService(comProps: IComProps) {
  const { style, className, children, api = '', dataKey = 'dwm_data_list', tableFormat = 'thousandsInit', 
    byType = 'competency_active', metric = 'wow_author_1w_active_cnt',  ...resetProps } = comProps || {};
  const gameCode = useSelector((state: any) => state?.dashboard?.currentGame?.game_code, shallowEqual);
  const data = useMemo(() => ({
    gameCode
  }), [gameCode]);

  // 格式化数据,处理好数据传给子组件
  const formatData = (data:any) => {
    const resultData = data || {};
    const dataList = resultData?.[dataKey] || [];
    // wow 没有中英文区分，直接拿后端的full_crz_name展示
    const chartData = dataList?.[0]?.list?.map((v: { full_crz_name: any; }) => ({
      name: v?.full_crz_name || '-',
      stack: "Total",
      type: "bar",
    })) || [];
    // 时间组
    const chartTime = dataList.map((v: { date_ymd: any; }) => v.date_ymd);
    chartData?.forEach((item: { data: any; }, index: string | number) => {
      const yData = chartTime.map((val: string, idx: string | number) => ({
        x: val,
        y: dataList?.[idx]?.list?.[index]?.value
      }));
      item.data = yData;
      return item;
    });
    const tableData: any[] = [];
    dataList?.forEach((item: { list: any[]; date_ymd: any; }) => {
      item?.list?.forEach(v => {
        tableData.push({
          date: item?.date_ymd,
          value: dataFormat({value: v?.value, formatRule: tableFormat}),
          name: v?.full_crz_name || '-',
        });
      });
    });
    return {
      chartData: chartData || [],
      tableData: tableData || []
    };
  };

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        trackData={['gameCode']}
        formatData={formatData}
        dataKey={'data'}
        beforeRequest={(data) => {
          const { filterVal, gameCode } = data;
          // 添加日期补齐逻辑，并格式化筛选器信息
          const defaultTimeRange = getDefaultUtcDateValue(filterVal?.timeType, filterVal?.rangeTime);
          const filterParams = getServiceFilterParams(filterVal, defaultTimeRange);
          const params = {
            game_code: gameCode,
            ...(filterParams || {}),
            by_type: byType,
            metric,
          };
          return params;
        }}>
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            ...resetProps
          }
        ))}
      </Service>
    </div>
  );
};
